module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }